<template>
	<v-row class="fill-height">
		<v-col>
			<v-row>
				<v-toolbar flat color="white">
					<v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
						{{ $t('today') }}
					</v-btn>
					<v-btn fab text color="grey darken-2" @click="prev()">
						<v-icon>mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn fab text color="grey darken-2" @click="next()">
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>

					<v-col cols="auto">
						<month-calendar />
					</v-col>

					<v-btn class="ml-4" outlined color="primary" :disabled="!anyFreeSlot" @click="cbDialog = true">
						<v-icon>mdi-bookmark-plus</v-icon>
					</v-btn>

					<v-spacer />

					<v-switch v-model="showCancelled" hide-details="true" :label="$t('show_canceled')"></v-switch>
				</v-toolbar>
			</v-row>
			<day-calendar />
			<create-booking v-if="cbDialog" @close="cbDialog = false" />
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import MonthCalendar from './components/MonthCalendar'
import DayCalendar from './components/DayCalendar'
import CreateBooking from './components/CreateBooking'

export default {
	name: 'Bookings',

	components: { MonthCalendar, DayCalendar, CreateBooking },

	data() {
		return {
			showCancelled: false,
			cbDialog: false
		}
	},

	computed: {
		...mapGetters({
			opnhrs: 'auth/opnhrs',
			date: 'bookings/date',
			anyFreeSlot: 'bookings/anyFreeSlot'
		})
	},

	watch: {
		showCancelled(value) {
			this.setShowCancelled(value)
		}
	},

	methods: {
		...mapMutations({
			saveDate: 'bookings/SAVE_DATE',
			setShowCancelled: 'bookings/SET_SHOW_CANCELED'
		}),
		next() {
			let date = this.$moment(this.date)
				.add(1, 'day')
				.format(this.$moment.HTML5_FMT.DATE)
			this.saveDate(date)
		},
		prev() {
			let date = this.$moment(this.date)
				.add(-1, 'day')
				.format(this.$moment.HTML5_FMT.DATE)
			this.saveDate(date)
		},
		setToday() {
			let date = new Date().toISOString().substr(0, 10)
			this.saveDate(date)
		}
	}
}
</script>

<style lang="scss" scoped>
.switch {
	display: flex;
	align-self: center;
}
</style>
